import { memo, useMemo } from "react";
import { generatePath } from "react-router";

import { cn } from "@/lib/chillnn/cn";
import { HotelTemplateType, type HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { StepHeader } from "../_step-header";
import { TodoListSectionItem } from "../_todo-list-section-item";
import { TodoListSectionWrapper } from "../_todo-list-section-wrapper";
import { TodoListWrapper } from "../_todo-list-wrapper";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	hotelTemplateSettings: HotelTopQuery["hotelTemplateSettings"];
	disabled: boolean;
};

const HOTEL_POLICY_NOT_REGISTERED_MESSAGE = "ホテルポリシーの設定をしてください";

export const Step3 = memo(
	({
		startGuide: { hotelID, isHotelPolicyRegistered, isPlanRegistered, isOptionRegistered },
		hotelTemplateSettings: { hotelTemplateType },
		disabled,
	}: Props) => {
		const showCheckBox = useMemo(() => hotelTemplateType === HotelTemplateType.NotSelected, [hotelTemplateType]);

		return (
			<div className={cn("space-y-4", disabled && "pointer-events-none opacity-30")}>
				<StepHeader title="Step3" description="プラン・オプションの登録（任意）" />

				<TodoListWrapper>
					<TodoListSectionWrapper>
						<TodoListSectionItem
							title={"プラン情報の登録"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })}
							checkBoxStatus={isPlanRegistered}
							requiredTime={10}
							showCheckBox={showCheckBox}
						/>
						<TodoListSectionItem
							title={"オプション情報の登録"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })}
							checkBoxStatus={isOptionRegistered}
							requiredTime={10}
							showCheckBox={showCheckBox}
						/>
					</TodoListSectionWrapper>
				</TodoListWrapper>
			</div>
		);
	},
);

Step3.displayName = "Step3";
